import {REQUEST_MANAGER_PERSON, REQUEST_MANAGER_PERSON_FAILURE, REQUEST_MANAGER_PERSON_SUCCESS} from "../../../constant/master/TransManagerPersonConstant";

const initialState = {
    manager_person: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const managerPersonReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_MANAGER_PERSON:
            return {
                ...state,
                manager_person: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_MANAGER_PERSON_SUCCESS:
            return {
                ...state,
                manager_person: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_MANAGER_PERSON_FAILURE:
            return {
                ...state,
                manager_person: {
                    data: [],
                    status: 'idle',
                },
            };
        default:
            return state;
    }
}
